@if (currencyItems.length > 0 || uniqueItems.length > 0) {
  <div class="moved-tier {{ cssClass }}" [class.moved-tier-hidden]="isHidden">
    <h4 class="tier-header">{{ sectionTitle }} <span class="moved" [class.up]="cssClass.includes('up')" [class.down]="cssClass.includes('down')">{{ icon }}</span></h4>
    <div class="moved-tier-items">
      @if (currencyItems.length > 0) {
        @if (groupingMode === 'movement') {
          <h4>Currency</h4>
        }
        @for (item of currencyItems; track item.name) {
          <div class="moved-item" [class.new-movement-group]="groupingMode === 'tier' && item.isNewMovementGroup">
            <app-item-label [baseType]="item.name" [image]="item.image" [showPreviousValue]="true"></app-item-label>
            @if (groupingMode === 'movement') {
              <span class="moved-tier-letter tier-{{ item.tierColor }}-color">&nbsp;({{ item.tier }})</span>
            } @else {
              @if (item.movementAmount && item.movementAmount !== 0) {
                <span class="moved" [class.up]="item.movementAmount > 0" [class.down]="item.movementAmount < 0">{{ item.movementIcon }}</span>
              }
            }
          </div>
        }
      }
      @if (uniqueItems.length > 0) {
        @if (groupingMode === 'movement') {
          <h4>Uniques</h4>
        }
        @for (item of uniqueItems; track item.baseType) {
          <div class="moved-item" [class.new-movement-group]="groupingMode === 'tier' && item.isNewMovementGroup">
            <div class="tier-item-type-base-type">
              <div>
                @if (alwaysGroupByBaseType || item.allUniques.length > 1) {
                  <app-tooltip-wrapper style="display: inline-block;">
                    <span class="normal-item-color">{{ item.baseType }}</span>
                    @if (groupingMode === 'movement') {
                      <span class="moved-tier-letter tier-{{ item.tierColor }}-color" title="{{ item.tier }}">&nbsp;({{ item.tierAbbr }})</span>
                    } @else {
                      @if (item.movementAmount && item.movementAmount !== 0) {
                        <span class="moved" [class.up]="item.movementAmount > 0" [class.down]="item.movementAmount < 0">{{ item.movementIcon }}</span>
                      }
                    }
                    @if (item.nonRestrictedUniques.length > 1) {
                      <ng-template #tooltip>
                        <span>
                          <strong>Non-Restricted Uniques</strong>
                          <br /><span class="normal-item-color">Average:</span> {{ item.averageValue }}{{ currency }}<span class="normal-item-color">, Lowest:</span> {{ item.lowestValue }}{{ currency }}
                        </span>
                        <span class="tooltip-section">
                          @for (unique of item.nonRestrictedUniques; track unique.name; let i = $index) {
                            @if (i > 0) { <br /> }
                            <span class="normal-item-color">{{ unique.name }}:</span> {{ unique.price }}{{ currency }}
                          }
                        </span>
                      </ng-template>
                    }
                  </app-tooltip-wrapper>
                } @else {
                  <app-item-label
                    [unique]="true"
                    [baseType]="item.allUniques[0].name"
                    [image]="item.allUniques[0].image"
                    [showPreviousValue]="true"
                  ></app-item-label>
                  @if (groupingMode === 'movement') {
                    <span class="moved-tier-letter tier-{{ item.tierColor }}-color" title="{{ item.tier }}">&nbsp;({{ item.tierAbbr }})</span>
                  } @else {
                    @if (item.movementAmount && item.movementAmount !== 0) {
                      <span class="moved" [class.up]="item.movementAmount > 0" [class.down]="item.movementAmount < 0">{{ item.movementIcon }}</span>
                    }
                  }
                }

                @if (!alwaysGroupByBaseType && item.allUniques.length === 1) {
                  <app-price-type-indicator [priceType]="item.allUniques[0].type" [isUnique]="true"></app-price-type-indicator>
                }
              </div>

              @if (alwaysGroupByBaseType || item.allUniques.length > 1) {
                @for (unique of item.allUniques; track unique.name) {
                  <div>
                    <app-item-label
                      [unique]="true"
                      [baseType]="unique.name"
                      [image]="unique.image"
                      [showPreviousValue]="true"
                    ></app-item-label>

                    <app-price-type-indicator [priceType]="unique.type" [isUnique]="true"></app-price-type-indicator>
                  </div>
                }
              }
            </div>
          </div>
        }
      }
    </div>
  </div>
}
